import createIcon from '../../createIcon';

/**
 * @component @name DeveloperBoard
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIgOVY3SDIwVjVDMjAgMy45IDE5LjEgMyAxOCAzSDRDMi45IDMgMiAzLjkgMiA1VjE5QzIgMjAuMSAyLjkgMjEgNCAyMUgxOEMxOS4xIDIxIDIwIDIwLjEgMjAgMTlWMTdIMjJWMTVIMjBWMTNIMjJWMTFIMjBWOUgyMlpNMTggMTlINFY1SDE4VjE5Wk02IDEzSDExVjE3SDZWMTNaTTEyIDdIMTZWMTBIMTJWN1pNNiA3SDExVjEySDZWN1pNMTIgMTFIMTZWMTdIMTJWMTFaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const DeveloperBoard = createIcon('DeveloperBoard', [
  [
    'path',
    {
      d: 'M22 9V7H20V5C20 3.9 19.1 3 18 3H4C2.9 3 2 3.9 2 5V19C2 20.1 2.9 21 4 21H18C19.1 21 20 20.1 20 19V17H22V15H20V13H22V11H20V9H22ZM18 19H4V5H18V19ZM6 13H11V17H6V13ZM12 7H16V10H12V7ZM6 7H11V12H6V7ZM12 11H16V17H12V11Z',
      key: 'musjiq',
    },
  ],
]);

export default DeveloperBoard;
